import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { loadTree } from "./loadTree";
import sidebarHelper from "../../../helpers/sidebar";
import UserMenu from "./UserMenu";
import TicketMenu from "./TicketMenu";
import RolePermissionMenu from "./RolePermissionMenu";
import authorizedComponent from "../../../helpers/authorized-component";
import AsideUserData from "./AsideUserData";
import SitePublisherMenu from "./SitePublisherMenu";
import ManageSitePublisherMenu from "./ManageSitePublisherMenu";
import ManageCampaignMenu from "./ManageCampaignMenu";
import SiteAdvertiseMenu from "./SiteAdvertiseMenu";
import ManageAdvertiseMenu from "./ManageAdvertiseMenu";
import FinanceMenu from "./FinanceMenu";
import ManageFinanceMenu from "./ManageFinanceMenu";
import ManageDiscountMenu from "./ManageDiscountMenu";
import ManageUserCustomerCoWorkerMenu from "./ManageUserCustomerCoWorkerMenu";
import ManageTicketMenu from "./ManageTicketMenu";
import CoworkerCustomerFinanceMenu from "./CoworkerCustomerFinanceMenu";
import CoworkerSitePublisherMenu from "./CoworkerSitePublisherMenu";
import SiteAdvertiseMenuCustomer from "./SiteAdvertiseMenuCustomer";
import ImageBrandHilite from "./ImageBrandHilite";
import SiteAdvertiseMenuCoworkerCustomer from "./SiteAdvertiseMenuCoworkerCustomer";
import ManageUsersByMarketer from "./ManageUsersByMarketer";

function Sidebar({
  permissionsUser,
  role,
  openItem = null,
  activeItem = null,
}) {
  useEffect(() => {
    loadTree();
  }, []);

  let tagUserMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.USER_MENU,
      permissionsUser
    )
  ) {
    tagUserMenu = <UserMenu openItem={openItem} activeItem={activeItem} />;
  }

  let tagRolePermissionMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.ROLE_PERMISSION_MENU,
      permissionsUser
    )
  ) {
    tagRolePermissionMenu = (
      <RolePermissionMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagMangeTicketMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.MANGE_TICKET,
      permissionsUser
    )
  ) {
    tagMangeTicketMenu = (
      <ManageTicketMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagManagePublishersMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.MANAGE_CATEGORY_PUBLISHER,
      permissionsUser
    )
  ) {
    tagManagePublishersMenu = (
      <ManageSitePublisherMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagManageCampaignsMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.MANAGE_CAMPAIGNS,
      permissionsUser
    )
  ) {
    tagManageCampaignsMenu = (
      <ManageCampaignMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagManageAdvertiseMenu = "";

  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.MANAGE_ADVERTISE,
      permissionsUser
    )
  ) {
    tagManageAdvertiseMenu = (
      <ManageAdvertiseMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagAdvertiseMenuCustomer = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.INFO_USER_COWORKER_CUSTOMER,
      permissionsUser
    )
  ) {
    tagAdvertiseMenuCustomer = (
      <SiteAdvertiseMenuCustomer openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagAdvertiseMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.ADVERTISE,
      permissionsUser
    )
  ) {
    tagAdvertiseMenu = (
      <SiteAdvertiseMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagCampaignMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.CAMPAIGNS,
      permissionsUser
    )
  ) {
    tagCampaignMenu = (
      <li className="nav-item">
        <Link
          to="/campaigns/all"
          className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "all-campaigns"
                      )} `}
        >
          <i className="nav-icon hl-notification"></i>
          <p>کمپین ها</p>
        </Link>
      </li>
    );
  }

  let tagCampaignsCoworkerSelectCustomer = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.PUBLISHERS_CUSTOMER,
      permissionsUser
    )
  ) {
    tagCampaignsCoworkerSelectCustomer = (
      <li className="nav-item">
        <Link
          to="/campaigns/coworker/select-customer"
          className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "select-customer-for-add-campaign"
                      )} `}
        >
          <i className="nav-icon hl-notification"></i>
          <p>کمپین ها</p>
        </Link>
      </li>
    );
  }

  let tagAdvertiseCoworkerSelectCustomer = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.PUBLISHERS_CUSTOMER,
      permissionsUser
    )
  ) {
    tagAdvertiseCoworkerSelectCustomer = (
      <SiteAdvertiseMenuCoworkerCustomer
        openItem={openItem}
        activeItem={activeItem}
      />
    );
  }

  let tagReportCampaignMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.CAMPAIGNS_REPORT,
      permissionsUser
    )
  ) {
    tagReportCampaignMenu = (
      <li className="nav-item">
        <Link
          to="/report/campaign"
          className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "report-campaigns"
                      )} `}
        >
          <i className="nav-icon hl-chart"></i>
          <p>گزارش کمپین ها</p>
        </Link>
      </li>
    );
  }

  let tagSitePublishers = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.PUBLISHERS,
      permissionsUser
    )
  ) {
    tagSitePublishers = <SitePublisherMenu activeItem={activeItem} />;
  }

  let tagMenuAllCampaignCustomer = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.INFO_USER_COWORKER_CUSTOMER,
      permissionsUser
    )
  ) {
    tagMenuAllCampaignCustomer = (
      <li className="nav-item">
        <Link
          to="/campaigns/customer/"
          className={`nav-link  d-flex
                    ${sidebarHelper.checkActiveItem(
                      activeItem,
                      "campaigns-customer"
                    )} `}
        >
          <i className="nav-icon hl-notification"></i>
          <p>کمپین ها</p>
        </Link>
      </li>
    );
  }

  let tagMenuAllCategoryUserSitePublisherCustomer = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.INFO_USER_COWORKER_CUSTOMER,
      permissionsUser
    )
  ) {
    tagMenuAllCategoryUserSitePublisherCustomer = (
      <li className="nav-item">
        <Link
          to="/category-user-site-publisher/customer/"
          className={`nav-link  d-flex
                    ${sidebarHelper.checkActiveItem(
                      activeItem,
                      "site-publisher-coworker"
                    )} `}
        >
          <i className="nav-icon hl-view-circle"></i>
          <p>گروه نمایش دهنده ها</p>
        </Link>
      </li>
    );
  }

  let tagCoworkerSitePublisherMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.PUBLISHERS_CUSTOMER,
      permissionsUser
    )
  ) {
    tagCoworkerSitePublisherMenu = (
      <CoworkerSitePublisherMenu activeItem={activeItem} />
    );
  }

  let tagFinanceMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.FINANCES,
      permissionsUser
    )
  ) {
    tagFinanceMenu = (
      <FinanceMenu openItem={openItem} activeItem={activeItem} role={role} />
    );
  }

  let tagManageFinanceMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.MANGE_FINANCES,
      permissionsUser
    )
  ) {
    tagManageFinanceMenu = (
      <ManageFinanceMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagManageUserCustomerCoWorkerMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.USER_CUSTOMER_COWORKER_MENU,
      permissionsUser
    )
  ) {
    tagManageUserCustomerCoWorkerMenu = (
      <ManageUserCustomerCoWorkerMenu activeItem={activeItem} />
    );
  }

  let tagManageUsersCustomerCoworker = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.USER_CUSTOMER_COWORKER_MENU,
      permissionsUser
    )
  ) {
    tagManageUsersCustomerCoworker = (
      <ManageFinanceMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagManageDiscount = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.MANGE_DISCOUNT,
      permissionsUser
    )
  ) {
    tagManageDiscount = (
      <ManageDiscountMenu openItem={openItem} activeItem={activeItem} />
    );
  }

  let tagTicketMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.TICKET_MENU,
      permissionsUser
    )
  ) {
    tagTicketMenu = <TicketMenu openItem={openItem} activeItem={activeItem} />;
  }

  let tagInfoUserMenuCustomerCoworker = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.INFO_USER_COWORKER_CUSTOMER,
      permissionsUser
    )
  ) {
    tagInfoUserMenuCustomerCoworker = (
      <li className="nav-item">
        <Link
          to="/user/info-customer-coworker"
          className={`nav-link  d-flex
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "info-customer-coworker"
          )} `}
        >
          <i className="nav-icon fa fa-info"></i>
          <p> اطلاعات شما </p>
        </Link>
      </li>
    );
  }

  let tagCoworkerCustomerFinanceMenu = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.USER_CUSTOMER_COWORKER_MENU,
      permissionsUser
    )
  ) {
    tagCoworkerCustomerFinanceMenu = (
      <CoworkerCustomerFinanceMenu
        openItem={openItem}
        activeItem={activeItem}
      />
    );
  }

  let tagAddUserByMarketer = "";
  if (
    authorizedComponent.isUserHasPermissionTreeMenu(
      authorizedComponent.listPermissionMenu.ADD_USER_BY_MARKETER,
      permissionsUser
    )
  ) {
    tagAddUserByMarketer = (
      <>
        <ManageUsersByMarketer openItem={openItem} activeItem={activeItem} />
        <li className="nav-item">
          <Link
            to="/marketer/all-ask-checkout"
            className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "all-checkout"
                      )} `}
          >
            <i className="nav-icon hl-money pl-2"></i>
            <p>تسویه حساب</p>
          </Link>
        </li>
      </>
    );
  }

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <ImageBrandHilite />

      <div className="sidebar" id="sidebar" style={{ direction: "rtl" }}>
        <div style={{ direction: "rtl" }}>
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link
                  to="/"
                  className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "welocome"
                      )} `}
                >
                  <i className="nav-icon hl-panel"></i>
                  <p>میزکار</p>
                </Link>
              </li>
              {tagManageUserCustomerCoWorkerMenu}
              {role == "همکار" ? "" : tagReportCampaignMenu}
              {role == "همکار" ? "" : tagCampaignMenu}
              {tagCampaignsCoworkerSelectCustomer}
              {tagManageCampaignsMenu}
              {role == "همکار" ? "" : tagAdvertiseMenu}
              {tagAdvertiseCoworkerSelectCustomer}
              {tagAddUserByMarketer}
              {tagManageAdvertiseMenu}
              {role == "همکار" ? "" : tagSitePublishers}
              {tagCoworkerSitePublisherMenu}
              {tagMenuAllCampaignCustomer}
              {tagAdvertiseMenuCustomer}
              {tagMenuAllCategoryUserSitePublisherCustomer}
              {tagManagePublishersMenu}
              {tagManageDiscount}
              {tagUserMenu}

              {tagRolePermissionMenu}
              {tagFinanceMenu}
              {tagManageFinanceMenu}
              {tagCoworkerCustomerFinanceMenu}

              {tagTicketMenu}
              {tagMangeTicketMenu}

              {tagInfoUserMenuCustomerCoworker}
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
}

const mapStateToProps = (state) => {
  return {
    permissionsUser: state.main.permissionsUser,
    role: state.main.role,
  };
};

const mapDispatchToProps = () => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
